import produce from 'immer'
import { assign } from 'lodash'

import {
  FETCH_DISH_TYPE,
  SET_DISH_TYPE_PAGE_TO_DIRTY,
  UPDATE_DISH_TYPE_ADDITIONAL_INGREDIENTS_DETAILS,
  UPDATE_DISH_TYPE_ALTERNATIVE_INGREDIENTS_DETAILS,
  UPDATE_DISH_TYPE_IGNORED_DETAILS,
  UPDATE_DISH_TYPE_IMAGE_DETAILS,
  UPDATE_DISH_TYPE_NOTES,
  UPDATE_DISH_TYPE_SIMPLE_DETAILS,
} from '../action-types'
import { DISH_TYPE_INITIAL_STATE } from '../initial-states'

const dishTypeReducer = (state = DISH_TYPE_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_DISH_TYPE_PAGE_TO_DIRTY:
      return produce(state, nextState => assign(nextState, action.payload))
    case FETCH_DISH_TYPE.START:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: true,
          fetchError: undefined,
          data: [],
        }),
      )

    case FETCH_DISH_TYPE.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: undefined,
          data: action.payload.data.dishType,
        }),
      )

    case FETCH_DISH_TYPE.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: action.error.message,
          data: [],
        }),
      )

    case FETCH_DISH_TYPE.CLEANUP:
      return { ...DISH_TYPE_INITIAL_STATE }

    case UPDATE_DISH_TYPE_SIMPLE_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: true,
          simpleDetailsError: undefined,
        }),
      )

    case UPDATE_DISH_TYPE_SIMPLE_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: false,
          simpleDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateDishTypeSimpleDetails,
          ),
        }),
      )

    case UPDATE_DISH_TYPE_SIMPLE_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: false,
          simpleDetailsError: action.error.message,
        }),
      )

    case UPDATE_DISH_TYPE_IGNORED_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isIgnoredDetailsLoading: true,
          ignoredDetailsError: undefined,
        }),
      )

    case UPDATE_DISH_TYPE_IGNORED_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isIgnoredDetailsLoading: false,
          ignoredDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateDishTypeIgnoredDetails,
          ),
        }),
      )

    case UPDATE_DISH_TYPE_IGNORED_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isIgnoredDetailsLoading: false,
          ignoredDetailsError: action.error.message,
        }),
      )

    case UPDATE_DISH_TYPE_IMAGE_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: true,
          imageDetailsError: undefined,
        }),
      )

    case UPDATE_DISH_TYPE_IMAGE_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: false,
          imageDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateDishTypeImageDetails,
          ),
        }),
      )

    case UPDATE_DISH_TYPE_IMAGE_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: false,
          additionalIngredientsDetailsError: action.error.message,
        }),
      )

    case UPDATE_DISH_TYPE_NOTES.START:
      return produce(state, nextState =>
        assign(nextState, {
          isNotesLoading: true,
          notesError: undefined,
        }),
      )

    case UPDATE_DISH_TYPE_NOTES.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isNotesLoading: false,
          notesError: undefined,
          data: assign(nextState.data, action.payload.data.updateDishTypeNotes),
        }),
      )

    case UPDATE_DISH_TYPE_NOTES.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isNotesLoading: false,
          notesError: action.error.message,
        }),
      )

    case UPDATE_DISH_TYPE_ADDITIONAL_INGREDIENTS_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isAdditionalIngredientsDetailsLoading: true,
          imageDetailsError: undefined,
        }),
      )

    case UPDATE_DISH_TYPE_ADDITIONAL_INGREDIENTS_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isAdditionalIngredientsDetailsLoading: false,
          additionalIngredientsDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateDishTypeAdditionalIngredientsDetails,
          ),
        }),
      )

    case UPDATE_DISH_TYPE_ADDITIONAL_INGREDIENTS_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isAdditionalIngredientsDetailsLoading: false,
          additionalIngredientsDetailsError: action.error.message,
        }),
      )

    case UPDATE_DISH_TYPE_ALTERNATIVE_INGREDIENTS_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isAlternativeIngredientsDetailsLoading: true,
          alternativeIngredientsDetailsError: undefined,
        }),
      )

    case UPDATE_DISH_TYPE_ALTERNATIVE_INGREDIENTS_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isAlternativeIngredientsDetailsLoading: false,
          alternativeIngredientsDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateDishTypeAlternativeIngredientsDetails,
          ),
        }),
      )

    case UPDATE_DISH_TYPE_ALTERNATIVE_INGREDIENTS_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isAlternativeIngredientsDetailsLoading: false,
          alternativeIngredientsDetailsError: action.error.message,
        }),
      )
    default:
      return state
  }
}

export default dishTypeReducer
